import React from "react";

const RenewSubscription = ({ onRenew }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <h2 className="text-2xl font-semibold mb-4">
        Your subscription has ended
      </h2>
      <p className="mb-6 text-gray-500">
        Please renew your subscription to continue using the platform.
      </p>
      <button
        onClick={onRenew}
        className="bg-[#2d348f] text-white px-6 py-2 rounded-md"
      >
        Renew Subscription
      </button>
    </div>
  );
};

export default RenewSubscription;
